import FieldProgress from "../../../generic/progress/progress";
import FieldConfig from "../../../proto/field-config";
import Project from "../../../../model2/project/project";


// Progress based on numebr of tasks - used in posrtolfio summary and table views

export default class FieldProjectProgressTasks extends FieldProgress {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Progress tasks"
        this.label      = "Progress tasks"

        // this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    canEdit(model:Project):boolean {
        return false
    }

}